export default {
      id: "reimbursements-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#reimbursements",
      toString: function () {
        return this.url;
      }
    }